import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';
import { notify } from 'src/components/notify';

const verifyMetaNumber = async (user, phone_number_id, pin) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/wa/number/verification/${phone_number_id}`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            data: { pin }
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        console.log(err);
        notify(err.message)

    }
};

export default verifyMetaNumber;
